export default class OrderRequestClient {
  constructor ({ email, password, company, firstName, lastName, phoneNumber, zipCode, taxId, city, address, customFields }) {
    this.categoryCode = 'FW'
    this.email = email
    this.password = password
    this.company = company
    this.firstName = firstName
    this.lastName = lastName
    this.phoneNumber = phoneNumber
    this.zipCode = zipCode
    this.taxId = taxId
    this.city = city
    this.address = address
    this.customFields = customFields
  }
}
